/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsStartFragmentMediaRegenerationMutationResponse, FragmentsStartFragmentMediaRegenerationPathParams } from "../models/FragmentsStartFragmentMediaRegeneration";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { fragmentsStartFragmentMediaRegeneration } from "../axios/fragmentsStartFragmentMediaRegeneration";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const fragmentsStartFragmentMediaRegenerationMutationKey = () => [{ url: '/fragments/v1/:fragmentId/regenerate-media' }] as const

export type FragmentsStartFragmentMediaRegenerationMutationKey = ReturnType<typeof fragmentsStartFragmentMediaRegenerationMutationKey>

export function fragmentsStartFragmentMediaRegenerationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = fragmentsStartFragmentMediaRegenerationMutationKey()
        return mutationOptions<FragmentsStartFragmentMediaRegenerationMutationResponse, ResponseErrorConfig<Error>, {fragmentId: FragmentsStartFragmentMediaRegenerationPathParams["fragmentId"]}, TContext>({
          mutationKey,
          mutationFn: async({ fragmentId }) => {
            return fragmentsStartFragmentMediaRegeneration(fragmentId, config)
          },
        })

}

/**
 * @summary Regenerate fragment media assets
 * {@link /fragments/v1/:fragmentId/regenerate-media}
 */
export function useFragmentsStartFragmentMediaRegeneration<TContext>(options: 
{
  mutation?: UseMutationOptions<FragmentsStartFragmentMediaRegenerationMutationResponse, ResponseErrorConfig<Error>, {fragmentId: FragmentsStartFragmentMediaRegenerationPathParams["fragmentId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? fragmentsStartFragmentMediaRegenerationMutationKey()

          const baseOptions = fragmentsStartFragmentMediaRegenerationMutationOptions(config) as UseMutationOptions<FragmentsStartFragmentMediaRegenerationMutationResponse, ResponseErrorConfig<Error>, {fragmentId: FragmentsStartFragmentMediaRegenerationPathParams["fragmentId"]}, TContext>
          

          return useMutation<FragmentsStartFragmentMediaRegenerationMutationResponse, ResponseErrorConfig<Error>, {fragmentId: FragmentsStartFragmentMediaRegenerationPathParams["fragmentId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<FragmentsStartFragmentMediaRegenerationMutationResponse, ResponseErrorConfig<Error>, {fragmentId: FragmentsStartFragmentMediaRegenerationPathParams["fragmentId"]}, TContext>
      
}